export const formatMoveInLabel = (date?: Date) => {
  if (!date) {
    return "Move-in";
  }

  return date.toLocaleDateString("en-GB", {day: "2-digit", month: "2-digit"});
};
